import React from 'react'
import { useEffect, useState } from 'react';
import ICalendarioFeriado from '../../interfaces/ICalendarioFeriado';
import ICalendarioMes from '../../interfaces/ICalendarioMes';
import CalendarioService from '../../services/CalendarioService.';
import CalendarioNovoModal from './CalendarioNovoModal';
import Swal from 'sweetalert2';

export default function CalendarioComponent({ feriados, setFeriados, calendarioID }: { feriados?: ICalendarioFeriado[], setFeriados: (feriados: ICalendarioFeriado[]) => void, calendarioID: number | null }) {
    const [ano, setAno] = useState(2021);
    const [calendario, setCalendario] = useState<ICalendarioMes[]>([]);
    const [feriadoVm, setFeriadoVm] = useState<ICalendarioFeriado | null>(null);
    const [showModal, setShowModal] = useState<boolean>(false);

    useEffect(() => {
        function criarCalendario() {
            let calen = meses.map(m => {

                let mesRetorno = {
                    mes: m.mes, descricao: m.descricao, semanas: JSON.parse(JSON.stringify(diasSemana))
                } as ICalendarioMes;

                let diaInicial = new Date(ano, m.mes - 1, 1).getDay();
                let dateFim = new Date(ano, m.mes, 0);
                let diaAtualSemana = diaInicial;

                if (diaInicial > 0) {
                    for (let index = 0; index < diaInicial; index++) {
                        mesRetorno.semanas[index].dias.push({ dia: 0, hoje: false });
                    }
                }

                for (let index = 1; index <= dateFim.getDate(); index++) {
                    mesRetorno.semanas[diaAtualSemana].dias.push({ dia: index, feriado: possuiEvento(index, m.mes, ano), hoje: verificarDiaAtual(index, m.mes, ano) });
                    diaAtualSemana++;

                    if (diaAtualSemana > 6)
                        diaAtualSemana = 0;
                }

                return mesRetorno;
            });
            setCalendario(calen);
        }

        criarCalendario()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ano, feriados]);

    const meses = [
        { mes: 1, descricao: 'Janeiro' },
        { mes: 2, descricao: 'Fevereiro' },
        { mes: 3, descricao: 'Março' },
        { mes: 4, descricao: 'Abril' },
        { mes: 5, descricao: 'Maio' },
        { mes: 6, descricao: 'Junho' },
        { mes: 7, descricao: 'Julho' },
        { mes: 8, descricao: 'Agosto' },
        { mes: 9, descricao: 'Setenbro' },
        { mes: 10, descricao: 'Outubro' },
        { mes: 11, descricao: 'Novembro' },
        { mes: 12, descricao: 'Dezembro' },
    ];

    const diasSemana = [
        { dia: 'Dom', dias: [] } as { dia: string, dias: any[] },
        { dia: 'Seg', dias: [] } as { dia: string, dias: any[] },
        { dia: 'Ter', dias: [] } as { dia: string, dias: any[] },
        { dia: 'Qua', dias: [] } as { dia: string, dias: any[] },
        { dia: 'Qui', dias: [] } as { dia: string, dias: any[] },
        { dia: 'Sex', dias: [] } as { dia: string, dias: any[] },
        { dia: 'Sab', dias: [] } as { dia: string, dias: any[] },
    ]

    function possuiEvento(dia: number, mes: number, ano: number): any {
        let diaFormatado = dia < 10 ? '0' + dia : dia;
        let mesFormatado = mes < 10 ? '0' + mes : mes;

        let dataDescricao = `${diaFormatado}/${mesFormatado}/${ano}`;

        const feriado = feriados?.find(f => f.dataFeriado === dataDescricao);

        return feriado;
    }

    function verificarDiaAtual(dia: number, mes: number, ano: number) {
        let dataAtual = new Date();
        if (dataAtual.getFullYear() === ano && (dataAtual.getMonth() + 1) === mes && dataAtual.getDate() === dia) {
            return true;
        }

        return false;
    }

    async function salvar(feriado: ICalendarioFeriado) {
        try {
            let feriadosVm = JSON.parse(JSON.stringify(feriados)) as ICalendarioFeriado[];

            let feriadoExists = feriadosVm.find(f => f.dataFeriado === feriado.dataFeriado);

            if (feriadoExists) {
                feriadoExists.descricao = feriado.descricao;

                if (calendarioID) {
                    await CalendarioService.atualizarFeriado(feriado);
                }
            } else {
                feriado.calendarioID = calendarioID ? calendarioID : 0;

                if (calendarioID) {
                    const result = await CalendarioService.criarFeriado(feriado);

                    feriado.id = result.id;
                }

                feriadosVm.push(feriado);
            }

            if (calendarioID) {
                await Swal.fire({
                    text: 'Feriado salvo com sucesso',
                    timer: 4000,
                    icon: 'success',
                    showConfirmButton: false
                });
            }

            setFeriados(feriadosVm);
            toggleModal();
        } catch (error) {
            Swal.fire({
                text: calendarioID ? 'Não foi possivel criar o Feriado' : 'Não foi possivel Atualizar o Feriado', //TODO: Tratar mensagem de erro
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        }
    }

    async function remover(feriado: ICalendarioFeriado) {
        try {
            if (calendarioID) {
                await CalendarioService.excluirFeriado(feriado.id);
                await Swal.fire({
                    text: 'Calendário removido com sucesso',
                    timer: 4000,
                    icon: 'success',
                    showConfirmButton: false
                });
            }

            let feriadosVm = JSON.parse(JSON.stringify(feriados)) as ICalendarioFeriado[];

            feriadosVm = feriadosVm.filter(f => f.id !== feriado.id);

            setFeriados(feriadosVm);



            toggleModal();
        } catch (error) {
            Swal.fire({
                text: 'Não foi possivel excluir o Feriado', //TODO: Tratar mensagem de erro
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        }
    }

    async function toggleModal(): Promise<void> {
        let show = !showModal;

        setShowModal(show);

        if (show === false) {
            setFeriadoVm(null);
        }
    }

    return <>
        <CalendarioNovoModal feriado={feriadoVm} salvar={salvar} remover={remover} toggleModal={toggleModal} show={showModal} />
        <div className="col-md-12" style={{ textAlign: 'center' }}>
            <h1 className="azul-agriholmes"><i onClick={() => {
                let anoModificar = ano - 1;
                setAno(anoModificar);
            }} style={{ cursor: 'pointer' }} className="azul-agriholmes fas fs-3 fa-chevron-left"></i> {ano} <i onClick={() => {
                let anoModificar = ano + 1;
                setAno(anoModificar);
            }} style={{ cursor: 'pointer' }} className="azul-agriholmes fas fs-3 fa-chevron-right"></i></h1>
        </div>
        {
            calendario.map(c => {
                return <div key={c.mes} className="col-md-12 col-sm-12 col-lg-4 mt-5">
                    <div className="calendario-mes">
                        <div className="col-md-12 mt-2">{c.descricao}</div>
                        <div className="row col-md-12 col-sm-12 text-center">
                            {
                                c.semanas.map(s => {
                                    return <div key={s.dia} className="col col-lg-1 mt-5 ms-2 mx-2">
                                        <div className="calendario-dias-semana">
                                            {s.dia}
                                        </div>
                                        {
                                            s.dias.map(d => {
                                                return <p onClick={() => {
                                                    if (d.dia === 0)
                                                        return;

                                                    if (d.feriado) {
                                                        setFeriadoVm(d.feriado);
                                                    } else {
                                                        let diaFormatado = d.dia < 10 ? '0' + d.dia : d.dia;
                                                        let mesFormatado = c.mes < 10 ? '0' + c.mes : c.mes;

                                                        let dataDescricao = `${diaFormatado}/${mesFormatado}/${ano}`;

                                                        setFeriadoVm({ dataFeriado: dataDescricao, descricao: '' } as ICalendarioFeriado);
                                                    }

                                                    toggleModal();
                                                }} key={`${ano}-${c.mes}-${d.dia}`} className={`calendario-dias-mes ${d.feriado ? 'calendario-dia-feriado' : ''} ${d.hoje ? 'calendario-dia-hoje' : ''}`} style={d.dia !== 0 ? { cursor: 'pointer' } : { color: '#FFF' }}>
                                                    {d.dia}
                                                </p>
                                            })
                                        }
                                    </div>
                                })
                            }
                        </div>
                    </div>
                </div>
            })
        }
    </>
}